<template>
	<div>
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="数据补充" :visible.sync="collectInfoVisible" width="65%">
			<el-table
                :data="collectRecordData"
				:key="editEnable"
                border
                class="table"
                ref="collectRecordTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px', fontSize:14 + 'px'}"
				stripe
            >
				<el-table-column prop="platformId" label="平台名称" width="150px">
					<template slot-scope="scope">
						<el-select v-if="scope.row.edit" v-model="scope.row.platformId" placeholder="请选择平台">
							<el-option key="" label="请选择平台" value=""></el-option>
							<el-option :key="0" label="官方网站" :value="0"></el-option>
							<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
						</el-select>
						<span v-else>{{platformFormat(undefined,undefined,scope.row.platformId)}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="companyUrl" label="网址">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.companyUrl"
						  placeholder="网址"
						></el-input>
						<span v-else>{{scope.row.companyUrl}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="mainBusiness" label="主营产品">
					<template slot-scope="scope">
						<el-input type=textarea :rows=3
						  v-if="scope.row.edit"
						  v-model="scope.row.mainBusiness"
						  placeholder="主营产品"
						></el-input>
						<span v-else>{{scope.row.mainBusiness}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="latestCollectTime" label="采集时间" width="160px"></el-table-column>
				<el-table-column prop="status" label="状态" width="115px">
					<template slot-scope="scope">
						{{scope.row.status==1?"失败":(scope.row.status==2?"采集完成":"开始执行采集")}}
					</template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
							type="text"
							icon="el-icon-edit"
							v-if="scope.row.edit==undefined||scope.row.edit==false"
							@click="handleRowEdit(scope.$index, scope.row)"
						>编辑</el-button>
						<el-button
							type="text"
							icon="el-icon-check"
							v-if="scope.row.edit"
							@click="handleRowSave(scope.$index, scope.row)"
						>保存</el-button>
						<el-button
							type="text"
							icon="el-icon-close"
							v-if="scope.row.edit"
							@click="handleRowCancel(scope.$index, scope.row)"
						>取消</el-button>
						<el-button
							type="text"
							icon="el-icon-delete"
							class="red"
							v-if="(scope.row.edit==undefined||scope.row.edit==false) && (!currentResource.trackerId || currentResource.trackerId == currentResource.createBy)"
							@click="handleRowRemove(scope.$index, scope.row)"
						>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<el-button
				type="primary"
				icon="el-icon-lx-add"
				class="handle-del mr10"
				style="margin-top:20px"
				@click="handleCollectInfoAdd"
			>添加记录</el-button>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="添加新纪录" :visible.sync="collectInfoAddVisible" width="45%">
			<el-form ref="collectInfoAddForm" :model="collectInfoAddForm" label-width="150px" :rules="collectRules">
				<el-form-item label="采集平台" prop="platformId">
					<el-select v-model="collectInfoAddForm.platformId" placeholder="请选择平台">
						<el-option key="" label="请选择平台" value=""></el-option>
						<el-option :key="0" label="官方网站" :value="0"></el-option>
						<el-option v-for="item in platformKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="采集地址" prop="companyUrl">
					<el-input v-model="collectInfoAddForm.companyUrl"> </el-input>
				</el-form-item>
				<el-form-item label="主营产品" prop="mainBusiness">
					<el-input type=textarea :rows=6 v-model="collectInfoAddForm.mainBusiness"> </el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
				<el-button @click="collectInfoAddVisible = false">取 消</el-button>
				<el-button type="primary" @click="addCollectInfo">保存</el-button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
import {updatePotentialResourcesCollectInfo, 
fetchCollectRecordData,getCollectRecord,saveCollectRecord, 
deleteCollectRecord} from '../../api/index';
import { getCurrentTime } from '../../utils/common';
export default {
    name: 'PotentialResourcesCollectInfoAdd',
    data() {
        return {
			label_style: {
				'width': "150px",
				'word-break': 'keep-all'
			},
			content_style: {
				'min-width': '200px',
				'word-break': 'break-all' //过长时自动换行
			},
			collectInfoAddVisible:false,
			collectInfoAddForm:{},
			collectRules: {
                platformId: [{ required: true, message: '请选择平台', trigger: 'blur' }],
				companyUrl: [{ required: true, message: '请输入网址', trigger: 'blur' }],
				mainBusiness: [{ required: true, message: '请输入主营产品', trigger: 'blur' }]
            },
			platformKV:[],
			collectRecordData:[],
			collectInfoVisible:false,
			editEnable:false,
			rowBackUp:{},
			currentResource:{},
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
			contactTypeKV:[{"key":0,"value":"手机"},{"key":1,"value":"固定电话"},{"key":2,"value":"QQ"},{"key":3,"value":"邮箱"},{"key":4,"value":"微信"},{"key":5,"value":"其他"}]
		};
    },
    methods: {
		setDatasource(row, companyInfoPlatformKV) {
			this.currentResource = row;
			this.platformKV = companyInfoPlatformKV
			this.getCollectRecordList(row);
			this.collectInfoVisible = true;
		},
		//获取采集列表
		getCollectRecordList(row){
			let param = {};
			param["resourcesId"] = row.id;
			fetchCollectRecordData(param).then(res => {
				if (res.code == 0) {
					this.collectRecordData = res.data;
					this.collectInfoVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		//保存采集内容
		addCollectInfo() {
			this.$refs.collectInfoAddForm.validate(valid => {
				if (valid) {
					this.collectInfoAddForm["resourcesId"] = this.currentResource["id"];
					this.collectInfoAddForm["latestCollectTime"] = getCurrentTime("yyyy-MM-dd hh:mm:ss");
					this.collectInfoAddForm["status"] = 2
					saveCollectRecord(this.collectInfoAddForm).then(res=>{
						if (res.code == 0) {
							this.collectInfoAddVisible = false;
							this.getCollectRecordList(this.currentResource);
						} else {
							this.$message.error(`获取数据详情失败！` + res.message);
						}
					});
				} else {
					this.$message.error('数据信息不完整！');
				}
			})
		},
		getTableScollTop() {
			this.scrollTop = this.$refs.collectRecordTable.bodyWrapper.scrollTop;
		},
		setTableScollTop() {
			setTimeout(() => {
				this.$refs.collectRecordTable.bodyWrapper.scrollTop = this.scrollTop;
			}, 13)
		},
		handleRowEdit(index, row) {
			this.getTableScollTop();
			this.rowBackUp = {};
			for(var item in row) {
				this.rowBackUp[item] = row[item];
			}
			row.edit = true;
			this.editEnable=true;
			this.setTableScollTop();
		},
		handleRowSave(index, row) {
			this.$confirm('确定要初始化选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
						saveCollectRecord(row).then(res=>{
							if (res.code == 0) {
								this.$message.success('保存成功！');
								row.edit = false;
								this.editEnable=false;
								this.setTableScollTop();
							} else {
								this.$message.error(`保存失败！` + res.message);
							}
						})
					})
				.catch(() => {});
		},
		handleRowCancel(index, row) {
			let isNotChange = true;
			delete row["edit"];
			for(var item in row) {
				isNotChange = this.rowBackUp[item] == row[item];
				if (!isNotChange) {
					break;
				}
			}
			if (isNotChange) {
				row.edit=false;
				this.editEnable=false;
				this.setTableScollTop();
				return;
			}
			this.$confirm('确定要取消修改吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in row) {
						row[item]= this.rowBackUp[item]?this.rowBackUp[item]:"";
					}
					row.edit=false;
					this.editEnable=false;
					this.setTableScollTop();
                })
                .catch(() => {});
		},
		handleRowRemove(index, row) {
			// 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteCollectRecord([row.id]).then(res=>{
						if (res.code == 0) {
							this.$message.success("删除成功！");
							this.getCollectRecordList(this.currentResource);
						}else{
							this.$message.error("删除失败！");
						}
					})
                })
                .catch(() => {});
		},
		handleCollectInfoAdd(){
			this.collectInfoAddVisible = true;
			this.collectInfoAddForm = {}
		},
		analysisData() {
			if(this.platformReg == undefined || this.platformReg == "") {
				this.$message.error(`请选择数据来源！`);
				return;
			}
			if (this.sourceForm["data"] == undefined || this.sourceForm["data"] == "") {
				this.$message.error(`请输入需要解析的内容！`);
				return;
			}
			let reg = new RegExp(this.platformReg)
			var result = reg.exec(this.sourceForm["data"]);
			if (result) {
				for (var key in result.groups) {
					if (key == "areaInfo") {
						let areaInfo = result.groups[key];
						areaInfo = areaInfo.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim();
						let indexOf = areaInfo.indexOf('省');
						let province = areaInfo.substring(0, indexOf + 1);
						areaInfo = areaInfo.substring(indexOf + 1, areaInfo.length);
						let provinceId = this.getAreaInfoId(this.provinceKV, province);
						if (provinceId){
							this.$set(this.form, "provinceId", provinceId); 
							getAreaKv(provinceId).then(res => {
								if (res.code == 0) {
									this.cityKV = res.data;
									indexOf = areaInfo.indexOf('市');
									let city = areaInfo.substring(0,  indexOf + 1);
									let cityId = this.getAreaInfoId(this.cityKV, city);
									if (cityId) { 
										this.$set(this.form, "cityId", cityId); 
										getAreaKv(cityId).then(res => {
											if (res.code == 0) {
												this.areaKV = res.data;
												let area = areaInfo.substring(indexOf + 1, areaInfo.length);
												let areaId = this.getAreaInfoId(this.areaKV, area);
												if (areaId) {
													this.$set(this.form, "areaId", areaId);
												}
											} else {
												this.$message.error("获取区域信息失败！" + res.message);
											}
										})
									}	
								} else {
									this.$message.error("获取区域信息失败！" + res.message);
								}
							})			
						}
					} else if (key.endsWith("Capital")){
						let capital = result.groups[key];
						capital = capital.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim();
						if (key == "registeredCapital") {
							let i = 0;
							for(; i < this.capitalType.length; i++) {
								if (capital.indexOf(this.capitalType[i]) > -1) {
									this.$set(this.form, 'capitalType', this.capitalType[i]);
									break;
								}
							}
							if (i == this.capitalType.length) {
								this.$set(this.form, 'capitalType', '人民币');
							}
						}
						capital = /[0-9.,]*/.exec(capital);
						if (capital) {
							let money = capital[0];
							this.$set(this.form, key, money.replaceAll(',', ''));
						}
					} else if (key.endsWith("Date") || key.endsWith("tel") || key.endsWith("mail") || key.endsWith("address") || key == "website"){
						let value = result.groups[key];
						if (value.indexOf('暂无') == -1) {
							value = value.replaceAll('\n', '').replaceAll(' ', '').trim();
							this.$set(this.form, key, value);
						}
					} else {
						let value = result.groups[key];
						this.$set(this.form, key, value.replaceAll('\n', '').replaceAll(' ', '').replaceAll('-', '').trim());
					}
				}
				this.activeName = "baseTab";
			}
		},
		platformFormat(row, column, cellValue) {
			if (cellValue == -1) {
				return "经营范围";
			} else if (cellValue == 0) {
				return "企业官网";
			} else {
				let index = this.platformKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
				});
				if (index === -1) return cellValue;
				return this.platformKV[index].value;
			}
		}
    }
};
</script>
<style>
	.el-dropdown-link {
		cursor: pointer;
		color: #409EFF;
	}
	.el-icon-arrow-down {
		font-size: 12px;
	}
	.table-header {
		font-size:14px;
	}
</style>